import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"

import GatsbyImageBanner from "./gatsby-image-banner"
import { getLanguage } from "../../utils"

const StyledBanner = styled.div`
  position: relative;
  z-index: 1;

  ${props =>
    props.bannerFixed
      ? `max-height: 45rem;`
      : `
    height: 15rem;
    
    @media (min-width: 769px) {
      height: 30rem;
    }
  
    @media (min-width: 1024px) {
      height: ${props.customBannerHeight ? props.customBannerHeight : "45rem"};
    }
  `}

  .gatsby-image-wrapper img {
    object-position: ${props => props.imagePosition} !important;
    ${props =>
      props.bannerFixed && "max-height: 45rem;object-fit: contain !important"};
  }

  ${props =>
    props.isVideo &&
    `
      height: auto !important;
      width: 100%;
      max-width: 71rem;
      margin: 0 auto;

      video, iframe {
        width: 100%;
        max-width: 100%;
      }

      .iframe-container{
        position: relative;
        padding-bottom: 56.25%;

        iframe {
          position: absolute;
          top:0;
          left: 0;
          height: 100%;
        }
      }
    `};

  &.hints-banner {
    margin-top: 2rem;

    @media (min-width: 769px) {
      margin-top: 5rem;
    }
  }

  a {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

const Banner = ({
  image,
  videoFile,
  isYoutube,
  link,
  extraClass,
  imagePosition = "50% 0%",
  customBannerHeight,
  bannerFixed,
  centered = false,
}) => {
  return (
    <StyledBanner
      className={`banner ${extraClass && ""} ${videoFile ? "is-video" : ""}`}
      data-testid="banner"
      isVideo={videoFile}
      customBannerHeight={customBannerHeight}
      imagePosition={imagePosition}
      bannerFixed={bannerFixed}
    >
      {videoFile ? (
        isYoutube ? (
          videoFile !== "#" && (
            <div className="iframe-container">
              <iframe src={videoFile} frameBorder="0" title="Youtube video" />
            </div>
          )
        ) : (
          <video src={videoFile} controls={true} data-testid="video-banner" />
        )
      ) : (
        <GatsbyImageBanner image={image} alt={""} centered={centered} />
      )}
      {!videoFile && link ? (
        link.includes("http") ? (
          <a href={link} target="_blank" rel="noopener noreferrer">
            {" "}
          </a>
        ) : (
          <Link to={`${getLanguage()}/${link}`} />
        )
      ) : null}
    </StyledBanner>
  )
}

Banner.propTypes = {
  extraClass: PropTypes.string,
  link: PropTypes.string,
  title: PropTypes.string,
  isYoutube: PropTypes.string,
  videoFile: PropTypes.string,
  imagePosition: PropTypes.string,
  customBannerHeight: PropTypes.string,
  centered: PropTypes.bool,
  bannerFixed: PropTypes.bool,
}

export default Banner
